<template>
  <div class="login_box">
    <!-- <a href="javascript:;" class="jump" @click="$router.back(-1)" replace="">{{$t('lang.tg')}}</a> -->
    <div class="jump" @click="hasClickJump">{{$t('lang.tg')}}</div>
    <div class="bottom" v-if="$i18n.locale === 'zh'">
      <div class="logo_box">
        <img src="../../assets/images/bluelogozh.png" alt="" style="width:220px;">
      </div>
      <form action="">
        <div class="line firstline">
          <span>+ 86</span>
          <input type="text" placeholder="手机号" name="tel" v-model="tel" oninput="value=value.replace(/[^\d]/g,'')">
          <div @click="getCode" v-if="!isCountdownShow"><span></span>获取验证码</div>
          <div class="countdown" v-else><span></span>{{countdown}}S</div>
        </div>
        <div class="line">
          <input type="text" placeholder="短信验证码" name="code" v-model="code">
        </div>
      </form>
      <div class="login_buttoncn login_button" @click="register">{{$t('lang.dlzc')}}</div>
      <!-- <div class="login_buttoncn login_button" unclick v-else>{{$t('lang.dlzc')}}</div> -->
    </div>
    <div class="bottom" v-else>
      <div class="logo_box">
        <img src="../../assets/images/bluelogo.png" alt="">
      </div>
      <form action="">
        <div class="line firstline">
          <input style="width:calc(100% - 100px);padding-left:0;" type="text" placeholder="E-mail" name="email" v-model="email" v-validate="'required|email'">
          <div @click="getCodeEn" v-if="!isCountdownShow"><span></span>Get Code</div>
          <div class="countdown" v-else><span></span>{{countdown}}S</div>
        </div>
        <div class="line">
          <input type="text" placeholder="Enter the code sent to your email" name="encode" v-model="encode">
        </div>
        <p style="text-align:left;font-size:12px;margin-top:10px;">*Register to watch for free. If you don’t receive the code, please check your spam or try another email address. </p>
      </form>
      <div class="login_button" @click="registeren">{{$t('lang.dlzc')}}</div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "login.less";
</style>
<script>
import ModalApi from '../../components/ModalApi'
export default {
  mixins: [ModalApi],
  data () {
    return {
      tel: '',
      code: '',
      countdown: 60,
      timer: null,
      isCountdownShow: false,
      email: '',
      encode: ''
    }
  },
  created () {
    console.log(this.$store.state.login.token)
    // localStorage.setItem('token', '')
    // console.log(JSON.parse(localStorage))
  },
  methods: {
    getCode: function () {
      let self = this
      clearInterval(self.timer)
      if (self.tel.length === 11) {
        self.$http.post('https://goapi.gmic.cn/api/v1/get_code', {
          mobile: self.tel,
          code_type: 'reg'
        }).then(function (res) {
          console.log(res)
          if (res.data.code === 200) {
            self.isCountdownShow = true
            self.timer = setInterval(function () {
              if (self.countdown > 0) {
                self.countdown--
              } else {
                self.isCountdownShow = false
                clearInterval(self.timer)
                self.countdown = 60
              }
            }, 1000)
          } else {
            self.alert(res.data.msg)
          }
        }).catch(function (err) {
          console.log(err)
        })
      } else {
        self.alert('请正确输入手机号')
      }
    },
    getCodeEn: function () {
      let self = this
      clearInterval(self.timer)
      self.$validator.validate().then(result => {
        if (result) {
          self.$http.post('https://goapi.gmic.cn/api/v1/get_email_code', {
            email: self.email,
            code_type: 'reg'
          }).then(function (res) {
            console.log(res)
            if (res.data.code === 200) {
              self.isCountdownShow = true
              self.timer = setInterval(function () {
                if (self.countdown > 0) {
                  self.countdown--
                } else {
                  self.isCountdownShow = false
                  clearInterval(self.timer)
                  self.countdown = 60
                }
              }, 1000)
            } else {
              self.alert(res.data.msg)
            }
          }).catch(function (err) {
            console.log(err)
          })
        } else {
          // console.log('Please input your e-mail.')
          self.alert('Please input your e-mail.', 'Notice', 'Confirm')
        }
      })
    },
    register: function () {
      console.log('register')
      let self = this
      if (self.tel.length !== 11) {
        self.alert('请正确输入手机号')
        return
      }
      if (self.code.length === 0) {
        self.alert('请正确输入验证码')
        return
      }
      self.$http.post('https://goapi.gmic.cn/api/v1/login', {
        user_mobile: self.tel,
        verify_code: self.code
      }).then(function (res) {
        console.log(res)
        if (res.data.code === 200) {
          console.log(res.data)
          localStorage.setItem('tel', self.tel)
          self.$store.commit('setToken', res.data.data.token)
          self.$store.commit('setFinishStatus', res.data.data.profile_finished)
          if (res.data.data.profile_finished) {
            self.alert({slot: 'slotA'}, '您已注册成功', '确认', function () {
              self.$router.replace({
                path: '/'
              })
            })
          } else {
            self.$router.replace({
              path: '/infor'
            })
          }
        } else {
          self.alert(res.data.msg)
        }
      }).catch(function (err) {
        console.log(err)
        self.alert('请求失败，请稍后再试')
      })
    },
    registeren: function () {
      // console.log('registeren')
      let self = this
      if (self.email.length === 0) {
        self.alert('Please input your e-mail.')
        return
      }
      if (self.encode.length === 0) {
        self.alert('Please enter the code sent to your email.')
        return
      }
      self.$validator.validate().then(result => {
        if (result) {
          self.$http.post('https://goapi.gmic.cn/api/v1/login_by_email', {
            email: self.email,
            verify_code: self.encode
          }).then(function (res) {
            console.log(res)
            if (res.data.code === 200) {
              // console.log(res.data)
              localStorage.setItem('email', self.email)
              self.$store.commit('setToken', res.data.data.token)
              self.$store.commit('setFinishStatus', res.data.data.profile_finished)
              if (res.data.data.profile_finished) {
                self.alert('You have successfully registered!', 'Notice', 'Confirm', function () {
                  self.$router.replace({
                    path: '/'
                  })
                })
              } else {
                self.$router.replace({
                  path: '/infor'
                })
              }
            } else {
              self.alert('Invaild Code!', 'Notice', 'Confirm')
            }
          }).catch(function (err) {
            console.log(err)
            self.alert('Request failed, please try again later.', 'Notice', 'Confirm')
          })
        } else {
          // console.log('Please input your e-mail.')
          self.alert('Please input your e-mail.', 'Notice', 'Confirm')
        }
      })
    },
    hasClickJump: function () {
      localStorage.setItem('isClickJump', '1')
      this.$router.replace({
        path: '/'
      })
    }
  },
  destroyed () {
    clearInterval(self.timer)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/login.vue